export enum TIPO_TRATAMIENTO {
  DR = 'Dr.',
  DRA = 'Dra.',
  SUPLENTE = 'Seleccionado Suplente'
}
export type KEYS_TIPO_TRATAMIENTO = keyof typeof TIPO_TRATAMIENTO

export enum ESTADO_DENUNCIA {
  PENDIENTE = 'Pendiente',
  ACTIVA = 'Activa',
  BAJA = 'Baja'
}
export type KEYS_ESTADO_DENUNCIA = keyof typeof ESTADO_DENUNCIA

export enum TIPO_DIAS_SEMANA {
  LUNES = 'L',
  MARTES = 'M',
  MIERCOLES = 'M',
  JUEVES = 'M',
  VIERNES = 'M'
}
export type KEYS_TIPO_DIAS_SEMANA = keyof typeof TIPO_DIAS_SEMANA

export enum TIPO_COMISION {
  DISC = 'Comisión de Disciplina',
  ACUS = 'Comisión de Acusación',
  LABO = 'Comisión de Labor',
  PLEN = 'Plenario',
  JURA = 'Jurado de Enjuiciamiento',
  CORT = 'Corte Suprema de Justicia de la Nación'
}
export type KEYS_TIPO_COMISION = keyof typeof TIPO_COMISION
